import { createSlice } from "@reduxjs/toolkit";
import { GetAllTags } from "store/middlewares/dataManagement/tags";

// isDeleteMeFulFilled
export const tagsSlice = createSlice({
  name: "tags",
  initialState: {
    tagsLoading: true,
    tags: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllTags.pending, (state) => {
        state.tags = state.tags?.result?.length > 0 ? state.tags : null;
      })
      .addCase(GetAllTags.fulfilled, (state, action) => {
        state.tagsLoading = false;
        state.tags = action.payload.response;
      })
      .addCase(GetAllTags.rejected, (state) => {
        state.tagsLoading = false;
        state.tags = null;
      });
  },
});

export default tagsSlice.reducer;
